module.exports = __webpack_public_path__ + "static/media/APP_OfficeWorm_152x174_5.31e16728.png";